// import elementVariables from '@/styles/element-variables.scss'
import defaultSettings from '@/settings';
export default {
  namespaced: true,
  state: () => ({
    fixedHeader: defaultSettings.fixedHeader,
    showSettings: defaultSettings.showSettings,
    showTagsView: defaultSettings.showTagsView,
    showSidebarLogo: defaultSettings.showSidebarLogo,
    sidebarTextTheme: defaultSettings.sidebarTextTheme
  }),
  mutations: {
    CHANGE_SETTING(payload) {
      const {
        key,
        value
      } = payload;
      if (Object.prototype.hasOwnProperty.call(this, key)) {
        this[key] = value;
      }
    }
  }
};